const userProfile = state => state.userProfile;
const userProfileEdit = state => state.userProfileEdit;

const getHomeTimeTable = state => state.getHomeTimeTable;
const getUserInfo = state => state.getUserInfo;
const getBaseInfo = state => state.getBaseInfo;
const getParamListelEctricBooks = state => state.getParamListelEctricBooks;
const getMyEbookList = state => state.getMyEbookList;
const getListClass = state => state.getListClass;
const getListBookType = state => state.getListBookType;
const practiceActive = state => state.practiceActive;
const paramActivityList = state => state.paramActivityList;
const getActivityList = state => state.getActivityList;
const getALLProvice = state => state.getALLProvice;
const getListTypeSchool = state => state.getListTypeSchool;
const dataTypePractice = state => state.dataTypePractice;
const dataBookGroup = state => state.dataBookGroup;
const dataSubject = state => state.dataSubject;
const pramPracticeChart = state => state.pramPracticeChart;
const getProcessPracticeChart = state => state.getProcessPracticeChart;
const paramLeaningProcess = state => state.paramLeaningProcess;
const dataListProcessLearing = state => state.dataListProcessLearing;
const dataOverSubjectChart = state => state.dataOverSubjectChart;
const paramProcessChat = state => state.paramProcessChat;
const dataListProcessChat = state => state.dataListProcessChat;
const displayDetail = state => state.displayDetail;
const changeClass = state => state.changeClass;

export default {
    userProfile,
    userProfileEdit,
    getHomeTimeTable,
    getUserInfo,
    getBaseInfo,
    getParamListelEctricBooks,
    getMyEbookList,
    getListClass,
    getListBookType,
    practiceActive,
    paramActivityList,
    getActivityList,
    getALLProvice,
    getListTypeSchool,
    dataTypePractice,
    dataBookGroup,
    dataSubject,
    pramPracticeChart,
    getProcessPracticeChart,
    paramLeaningProcess,
    dataListProcessLearing,
    dataOverSubjectChart,
    paramProcessChat,
    dataListProcessChat,
    displayDetail,
    changeClass
};